import React, { Component } from "react";
import classnames from "classnames";

import { Fader } from "@formant/ui/component/common/Fader";

import * as styles from "./TeleopModuleSlot.scss";

export interface ITeleopModuleSlotProps {
    visible: boolean;
    fullscreen?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export class TeleopModuleSlot extends Component<ITeleopModuleSlotProps> {
    public render() {
        const { visible, className, children, fullscreen } = this.props;

        return (
            <Fader
                visible={visible}
                className={classnames(
                    styles["teleop-module-slot"],
                    fullscreen && styles.fullscreen,
                    className,
                )}
            >
                {children}
            </Fader>
        );
    }
}
